var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"firebaseui-auth-container"}},[_c('facebook-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.signInByFacebook}}),_c('google-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.signInByGoogle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }